import { restore, createEvent } from 'effector';

export type ViewMode = 'cards' | 'compact';

export const setViewMode = createEvent<ViewMode>()

export const $viewMode = restore(setViewMode, 'cards');
